<template>
    <div class="header">
        <!-- 头部区域 -->
        <el-header class="cont_flex">
            <div class="top_head_left">

                <span><el-link href="/Welcome" :underline="false" style="font-size: 14px;color: #000000;"><i class="el-icon-s-home"></i> 车辆后台管理</el-link></span>

                <div class="top_head_center">
                    <i class="el-icon-date"></i>
                    <span>{{ nowDate }}</span>
                    <span>{{ nowWeek }}</span>
                </div>
            </div>

            <div class="top_head_center2">
              <span>{{ role_name }}</span>
            </div>

            <div class="top_head_right">
              <audio ref="audio" :src="newMessageSoundSrc"></audio>
              <span v-if="message>0">
              <el-button type="primary" icon="el-icon-message-solid
" @click="nativeMessagePage">
                {{message_status}} <b style="color:red"> {{message}} </b>
              </el-button>
              </span>
              <span v-if="message==0">
                <el-button type="primary" icon="el-icon-message-solid"> 0</el-button>
              </span>
              <el-dropdown class="margin_right">
                    <el-button type="primary">
                    <!-- <img src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg" /> -->
                    账号：{{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>

                    </el-button>
                    <el-dropdown-menu slot="dropdown">
<!--                        <el-dropdown-item @click.native="changePassword">修改密码</el-dropdown-item>-->
                        <el-dropdown-item @click.native="userInfo">用户中心</el-dropdown-item>
                        <el-dropdown-item @click.native="logout">注销</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </el-header>
         <!-- 新增编辑弹框 -->
        <el-dialog title="修改账号" :visible.sync="dialogPassword" width="550px" :append-to-body="true">
            <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="80px">

                <el-form-item label="账号" prop="user_name">
                <el-input v-model="pwdForm.user_name" readonly autocomplete="off" placeholder="请输入账号"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                <el-input v-model="pwdForm.password" autocomplete="off" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="repassword">
                <el-input v-model="pwdForm.repassword" autocomplete="off" placeholder="请再次输入密码"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="pwdReset_dialogForm('pwdForm')">取 消</el-button>
                <el-button type="primary" @click="pwdSubmitForm('pwdForm')">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
	import axios from '@/axios/axios';

  export default {
        data(){
            return {
              pollingInterval:null,
              newMessageSoundSrc: 'https://zkycyd.oss-cn-beijing.aliyuncs.com/public/msg.mp3',
              message: '0',
              newMessage: '0',
              message_url: '',
              message_status: '',
              nowWeek: "",
                nowDate: "",
                userName: '',
                role_name:'',
                campusList: [

                ],
                campusNow: 1,
                model:'15020923623',
                ip: "192.168.22.41",

                dialogPassword: false,
                pwdForm: {
                    user_name: sessionStorage.getItem('userName'),
                    password: '',
                    repassword: '',
                },
                pwdRules: {
                    password: [
                    { required: true, message: "请输入密码", trigger: "blur" }
                    ],
                    repassword: [
                    { required: true, message: "请再次输入密码", trigger: "blur" }
                    ],
                },
            }
        },
    created() {
            this.setNowTimes()
            this.campus()
            this.userName = window.sessionStorage.getItem('userName')
            this.role_name = window.sessionStorage.getItem('role_name')
        },
      mounted() {
        this.pollingInterval = setInterval(this.pollForNewMessage, 6000); // 每隔10分钟请求一次
      },
      beforeDestroy() {
        clearInterval(this.pollingInterval);
      },
        methods:{
          async pollForNewMessage() {
              const param = {
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.getPendingOrder(param).then(res=>{
                if(res.code == 200){
                  this.newMessage = res.data.total
                  this.message_url = res.data.to_url
                  this.message_status = res.data.status
                  if(this.newMessage>this.message){
                    this.$refs.audio.play();
                  }
                  this.message = this.newMessage
                }else{
                  //console.log('res-msg-error',res.msg)

                }
              }).catch(error=>{
                //console.log('catch-error',error);
              })

          },
          campus() {
                if (localStorage.getItem("campus") != null) {
                    this.campusNow = localStorage.getItem("campus");
                if (this.campusNow == 1) {
                    this.campusNow = "临沂大成运输公司1";
                }
                if (this.campusNow == 2) {
                    this.campusNow = "临沂大成运输公司2";
                }
                if (this.campusNow == 3) {
                    this.campusNow = "临沂大成运输公司3";
                }
                }
                if (this.campusList.length == 0) {
                    this.campusList= [
                        {id:1,name:'临沂大成运输公司1'},
                        {id:2,name:'临沂大成运输公司2'},
                        {id:3,name:'临沂大成运输公司3'},
                    ];
                    // this.$axios.get("campus.json").then((res) => {
                    //     if (res.status == 200) {
                    //     //console.log(res.data.campus);
                    //     this.campusList = res.data.campus;
                    //     } else {
                    //     this.$message.error("地区国家获取失败，请联系管理员~");
                    //     }
                    // });
                }
            },
            getCampusList(command) {
                // this.campusNow = command;
                localStorage.setItem("campus", command);
                this.campus();
                this.$message.success("已切换到" + this.campusNow);
            },
            //个人信息
            userInfo() {
                this.$router.push("/userInfo");
            },
            //用户退出
            logout() {

                this.$message.success('退出成功');
                window.sessionStorage.clear();
                this.$router.push("/login");

                // const param = {
                //     token: window.localStorage.getItem('token')
                // }
                // //console.log(param);
                // this.$axios.getOutAdmin(param).then(res=>{
                //     //console.log(res);
                //     if(res.code == 0){
                //         this.$message.warning(res.token);
                //         window.localStorage.clear();
                //         this.$router.push("/login");
                //     }
                // }).catch(error=>{
                //     //console.log(error);
                // })

            },

            setNowTimes() {
                //获取当前时间
                let myDate = new Date();
                let wk = myDate.getDay();
                let yy = String(myDate.getFullYear() + " 年");
                let mm = myDate.getMonth() + 1 + " 月";
                let dd = String(
                    myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate()
                )+ " 日";
                let weeks = [
                "星期日",
                "星期一",
                "星期二",
                "星期三",
                "星期四",
                "星期五",
                "星期六",
                ];
                let week = weeks[wk];
                this.nowDate = yy + " - " + mm + " - " + dd;
                this.nowWeek = week;
            },
            changePassword() {
                this.dialogPassword = true
            },
            pwdReset_dialogForm(formName) {
                this.dialogPassword = false
                this.$nextTick(() => {
                    this.$refs[formName].resetFields()
                })
            },
            pwdSubmitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let url = "api/sys.employee_Lz/setPassword";
                        const param = {
                            id: sessionStorage.getItem('user_id'),
                            password: this.pwdForm.password,
                            repassword: this.pwdForm.repassword,
                            access_token: sessionStorage.getItem('token'),
                            company_id: sessionStorage.getItem('company_id'),
                        }
                        axios.post(url,param).then(res => {
                            this.$message.success(res.msg)
                            this.dialogPassword = false
                        }).catch(function (error) {
                            //console.log(error);
                        })
                    }
                })
            },
          //跳转订单处理
          nativeMessagePage(){
            window.location.href = window.location.origin+'/'+this.message_url; // 替换为你要跳转的URL
          },
        }
    }

</script>

<style scoped>
    .el-header {
        background-color: #ffffff;
        display: flex;
        justify-content: space-between;
        padding-left: 0;
        align-items: center;
        color: #000;
        font-size: 14px;
        line-height: 24px;
      border-bottom: 1px solid #999999;
    }
    .top_head_left {
        width: 400px;
        display: flex;
        align-items: center;
      font-size: 14px;
      line-height: 24px;
    }
        .top_head_left img {
        width: 50px;
        height: 50px;
    }
    .top_head_left span{
        margin-left: 15px;

    }
    .top_head_right {
        text-align: right;
    }
    .top_head_right img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        vertical-align: middle; margin-right: 10px;
    }
    .el-header .el-button {
        background-color: transparent;
        border: none;
        color: #000000;
    }
    .top_head_center {
        font-size: 14px;
        margin-left: 40px;
    }
    .el-submenu__title{
        text-align: left;
    }

</style>



// WEBPACK FOOTER //
// src/view/layout/Header.vue